import React, { useState, forwardRef, useImperativeHandle  ,useEffect} from 'react';
import {Modal} from 'react-bootstrap';
 import { Dropdown } from 'react-bootstrap';
 import axios from "axios";
  import { useNavigate ,useParams} from "react-router-dom";
  import swal from 'sweetalert';
const InviteCustomer = forwardRef((props, ref) => {
    const [inviteModal , setInviteModal] = useState(true);
    const [IngCatName,setIngCatName] = useState('')
    const [data, setData] = useState([])

  const navigate = useNavigate();

    const showInviteModal = () => {   
        
            setInviteModal(false)
            navigate('/Dashboard_1')

        }
   //////////////////
   const userPermissionsJSON = localStorage.getItem('USER_PERMISSIONS2');
   const userPermissions = JSON.parse(userPermissionsJSON);
   function getActionsForPage(pageName) {
     const pagePermissions = userPermissions.find(permission => permission.resource === pageName);
  console.log('actionsForPage',pagePermissions); 
    if (pagePermissions) {
        return pagePermissions.action;
    } else {
   navigate('/dashboard_1')
       return [];
    }
  }
  const pageName = 'IntTypes';
  const actionsForPage = getActionsForPage(pageName);
   /////////////////////
   const userdata1 = localStorage.getItem('USER_data');
   const userData = JSON.parse(userdata1);
     const userid = userData.id;
   //////////////////////////////////
    const [tableData, setTableData] = useState([]);
    const handleEdit = async (id, field, value) => {
   
             const updatedData = tableData.map((row) =>
              row.id === id ? { ...row, [field]: value } : row
             );
             setTableData(updatedData);
             const formData = new FormData();
             formData.append('_method', 'PATCH')
            formData.append('IngCategoryID', id);
             formData.append('IngCatName', value);
             formData.append('UserID',userid);
            

         // await axios.put(`https://suhba.education.com.ly/back/api/areas/${id}`, FormData) .catch(function (error)
         const error = await axios.put(`https://suhba.education.com.ly/back/api/ingredient_categories/${id}`, {
            [field]: value,  });
                if (error.response) {
                  console.log(error.response.data);
                  console.log(error.response.status);
                  console.log(error.response.headers);
                } else if (error.request) {
                  console.log(error.request);
                } else {
                  console.log('Error', error.message);
                }
                console.log(error.config);
                
             } 
            // console.log(formData);

            
            ///////////////////////////////////////////////
      const getcities = () => {
        axios.get('https://suhba.education.com.ly/back/api/ingredient_categories')
         .then(({ data }) => {
            setData(data)
         })}

         const [currentPage , setCurrentPage] = useState(1);
         const recordsPage = 8;
         //const lastIndex = currentPage * recordsPage;
        // const firstIndex = lastIndex - recordsPage;   
        // const records = data.slice(firstIndex, lastIndex);
       //  const npage = Math.ceil(data.length / recordsPage)
     //    const number = [...Array(npage + 1).keys()].slice(1)
     const input = document.querySelector('input[name="city"]');
     if(input)
{
     input.addEventListener('invalid', function (event) {
       if (event.target.validity.valueMissing) {
         event.target.setCustomValidity('الرجاء ادخال اسم نوع المكايل و مثال : ربطة , كيلوا ');
       } 
     })
     
     input.addEventListener('change', function (event) {
       event.target.setCustomValidity('');
     })}
        
     
        
      useEffect(() => {
        getcities();
        
        const myElement = document.getElementById('myElementId');
        if(myElement){

        if (selectedItem  === 'متوفر') {
          myElement.className = 'Complete';
        }else{
            myElement.className = 'Pending';
        }}               

    }, [])
    const createEmployee = async(e)=>{
        e.preventDefault();
        const formData = new FormData();
        formData.append('IngCatName', IngCatName);
        formData.append('UserID', userid);
        formData.append('status', "متوفر");
        await axios.post('https://suhba.education.com.ly/back/api/ingredient_categories', formData)
        .then(res=>{
            if(res.data.status === 200)
            swal("عذرا",res.data.message,"warning");
        } ) 
       
      //  const myElement = document.getElementById('inputcity');
      
        //   myElement.value = '';
          setIngCatName('')
        getcities();
    } 
    const [message, setMessage] = useState(null)

    const lastIndex = currentPage * recordsPage;
    const firstIndex = lastIndex - recordsPage;   
    const records = data.slice(firstIndex, lastIndex);
    const npage = Math.ceil(data.length / recordsPage)
    const number = [...Array(npage + 1).keys()].slice(1)
 	
    const [statusPriority, setStatusPriority] = useState([]);
	
    const handleAction =  async(id, field, value)	=> {
        		let temp = statusPriority.map((data) => {
			if (id === data.id) {
				return { ...data, status: value };
			}
			return data;
		});
		setStatusPriority(temp);
        const formData = new FormData();
        formData.append('_method', 'PATCH')
       formData.append('IngCategoryID', id);
        formData.append('status', value);
        formData.append('UserID', userid);
        console.log('formdata',formData)
    const error = await axios.put(`https://suhba.education.com.ly/back/api/ingredient_categories/${id}`, {
       [field]: value,  });
           if (error.response) {
             console.log(error.response.data);
             console.log(error.response.status);
             console.log(error.response.headers);
           } else if (error.request) {
             console.log(error.request);
           } else {
             console.log('Error', error.message);
           }
           console.log(error.config);
          } 
          const [selectedItem, setSelectedItem] = useState();

          const handleSelect = (eventKey, rowIndex) => {
            const updatedData = [...data];
            updatedData[rowIndex].status = eventKey;
            setSelectedItem(eventKey) 
            console.log(eventKey)

                       setData(updatedData);console.log('row',rowIndex);
          };
    return(
        <>
            <Modal className="modal fade" id="exampleModal1" show={inviteModal}  centered>                
                <div className="modal-content">
                    <div className="modal-header">
                        <h1 className="modal-title fs-5" id="exampleModalLabel1">أسماء انواع الوحدات</h1>
                        <button type="button" className="btn-close " style={{marginLeft: 0 }}  padding="" onClick={()=>showInviteModal()}></button>
                    </div>
                    <div className="modal-body py-2 px-3 ">
                        <div className="row">
                            <div className="col-xl-12">
                            <form  onSubmit={createEmployee}>

                                <div className="row">
                                    <div className="col-xl-12">
                                    <div className="row">
                                        
         
                                    </div>
                                    <div className="row">
                                    <div className="col-xl-3">
                                        <label className="form-label mt-3 ">الوحدة</label> 
                                         </div>
                                        <div className="col-xl-6">
                                        <div className="input-group ">
                                            <input style={{  height: "2rem" }} 
                                            type="text" 
                                            required  
                                            id="inputcity"
                                              name="city"
                                            className="form-control mt-3" 
                                              value={IngCatName}
                                             onChange={(e)=>{setIngCatName(e.target.value)}}/>
                                        </div>   </div>

                                         
                                          <div className="col-xl-3 pe-0" style={{ paddingTop:"0.375rem"}}>
                                              <button  id="toastr-success-top-left" className="btn btn-primary mt-2 me-2 btn-icon-xs">+</button>
                                        </div>
                                       </div>  
                                    </div>
                                    
                                </div>

                                </form>
                                <div className="table-responsive active-projects task-table my-2 mx-2" style={{  height: "400px" }}>
                                <table className="table">
                            <thead>
                                <tr> 
                                    <th scope="col">اسم الوحدة</th>
                                    <th scope="col">الحالة</th>
                                 </tr>
                            </thead>
                            <tbody>
                                {
                                    data.length > 0 && (
                                        data.map((row,key)=>(
                                            <tr key={key}> 
                                                
                                                <td  
                contentEditable
                 onBlur={(e) => handleEdit(row.IngCategoryID, 'IngCatName', e.target.textContent)}
              >
              {row.IngCatName}
              
                                                    
                                                    
                                                    
                                                     </td>
                                                     <td>     
                                                     <Dropdown  className="task-dropdown-2" onSelect={(eventKey, event) => handleSelect(eventKey, key)}>
                                                                            <div>
                                                        { row.status ==="متوفر" ?(
                                                       <Dropdown.Toggle  id="myElementId" as="div" className="Complete">
                                                       {row.status ? ` ${row.status}` : 'Select an option'}</Dropdown.Toggle>

                                                               ) : (

                                                                <Dropdown.Toggle id="myElementId" as="div" className="Pending">
                                                                {row.status ? ` ${row.status}`: 'Select an option'}</Dropdown.Toggle>

                                                            ) }
                                                            </div>
																
                                                                
                                                                <Dropdown.Menu className='task-drop-menu'>
																	<Dropdown.Item eventKey="غير متوفر" onClick={()=>handleAction(row.IngCategoryID,'status','غير متوفر')}>غير متوفر</Dropdown.Item>
																	<Dropdown.Item eventKey="متوفر" onClick={()=>handleAction(row.IngCategoryID,'status','متوفر')}>متوفر</Dropdown.Item>
 
																</Dropdown.Menu>
															</Dropdown>
                                                            		</td>
                                            </tr> 
                                        ))
                                    )
                                }
 
                            </tbody>
                        </table>
                                        </div>

                            </div>
                        </div>                                
                    </div>
                    
                </div>               
            </Modal>
        </>
    )
})
export default InviteCustomer;